import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import notificationMiddleware from './notificationMiddleware';

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(notificationMiddleware),
});

export default store;
